// extracted by mini-css-extract-plugin
export default {"melodyVideo":"gQ-z","isFullWidth":"hQ-z","landingPageVideo":"iQ-z","play":"jQ-z","iframeVideo":"kQ-z","playHidden":"lQ-z","fullwidth":"mQ-z"};